export const bannerData = [
  {
    id: 1,
    title: "main banner",
    img: "img/banner/organic.jpg",
    info: "Organic products are also available",
  },
  {
    id: 2,
    title: "immunity booster",
    img: "img/banner/booster.jpg",
    info: "Immunity booster products are also available",
  },
  {
    id: 3,
    title: "fight with corona",
    img: "img/banner/corona.png",
    info: "Let's fight with corona by accepting online contactless services",
  },
];

export const bannerTwoData = [
  {
    id: 1,
    title: "contactless",
    img: "img/banner/contactless.jpg",
    info: "Contactless delivery and pay option",
  },
  {
    id: 2,
    title: "quality",
    img: "img/banner/quality.jpg",
    info: "the quality assurance",
  },
  {
    id: 3,
    title: "upi pay",
    img: "img/banner/upipay.jpg",
    info: "Offers UPI pay option",
  },
];
